'use es6';

import { createSelector } from 'reselect';
import { getConsentToCommunicateMessage as getConsentToCommunicateMessageOperator } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
export const getConsentToCommunicateMessage = createSelector(getLatestWidgetData, widgetData => getConsentToCommunicateMessageOperator(widgetData));